/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedVtReportImageList } from '../models/PaginatedVtReportImageList';
import type { PatchedVtReportImage } from '../models/PatchedVtReportImage';
import type { VtReportImage } from '../models/VtReportImage';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LeadsSitesVtReportImagesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedVtReportImageList
     * @throws ApiError
     */
    public leadsSitesVtReportImagesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedVtReportImageList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-sites-vt-report-images/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns VtReportImage
     * @throws ApiError
     */
    public leadsSitesVtReportImagesCreate({
        requestBody,
    }: {
        requestBody: VtReportImage,
    }): CancelablePromise<VtReportImage> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/leads-sites-vt-report-images/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns VtReportImage
     * @throws ApiError
     */
    public leadsSitesVtReportImagesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this vt report image.
         */
        id: number,
    }): CancelablePromise<VtReportImage> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-sites-vt-report-images/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns VtReportImage
     * @throws ApiError
     */
    public leadsSitesVtReportImagesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this vt report image.
         */
        id: number,
        requestBody: VtReportImage,
    }): CancelablePromise<VtReportImage> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/leads-sites-vt-report-images/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns VtReportImage
     * @throws ApiError
     */
    public leadsSitesVtReportImagesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this vt report image.
         */
        id: number,
        requestBody?: PatchedVtReportImage,
    }): CancelablePromise<VtReportImage> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/leads-sites-vt-report-images/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public leadsSitesVtReportImagesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this vt report image.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/leads-sites-vt-report-images/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
